import { createEventBus } from "../Common/eventBusFactory";

export const eventBus = createEventBus();

export const ON_ADD_LIVE_STREAM = "onAddLiveStream";
